import { Component, OnInit } from '@angular/core';

import { Router, RouterModule } from '@angular/router';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { configuration } from '../../environments/config';
import { RoutingStateService } from '../shared/services/routing-state.service';


import { OidcService } from '../shared/services/oidc.service';
import { deviceService } from '../shared/servicesHardware/deviceService';
import { url } from 'inspector';
import { HttpParams } from '@angular/common/http';
import { tools } from '../shared/services/tools';
import { GetJsonObjectService } from '../shared/services/get-json-object.service';
import { first } from 'rxjs/operators';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '../material-module';
import { environment } from '../../environments/environment';


@Component({
	selector: 'app-login',
	standalone: true,
	imports: [MaterialModule, FormsModule, ReactiveFormsModule, CommonModule, RouterModule],
	templateUrl: 'login.component.html',
	styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {

	public loginForm!: FormGroup;
	public loading = false;
	public submitted = false;
	public hide = true;
	public error = '';
	public lang: any;

	public currentSocietyShortName: string = "";
	public getJsonDone: boolean = false;
	public imgLogo = "./assets/data/" + configuration.logo;


	public loginFailed: boolean = false;
	public userProfile: object | undefined;
	public historySessions: user[] = [];

	constructor(
		private routingStateService: RoutingStateService,
		private formBuilder: FormBuilder,
		private router: Router,
		private oidc: OidcService,
		private tools: tools,
		private getService: GetJsonObjectService,
		private deviceService: deviceService
	) {
		this.lang = "fr";

	}

	ngOnInit() {
		this.loginForm = this.formBuilder.group({
			login: ['', Validators.email],
			password: ['', Validators.required],
			checkBox: ['']
		});

		//read for localSession password history       
		this.deviceService.decryptData("usersHistory")
			.then(resp => {
				if (resp != null)
					this.historySessions = JSON.parse(resp);
			});

	}

	historySelected(userSelected: any) {
		this.loginForm.controls['login'].setValue((userSelected.login).trim());
		this.loginForm.controls['password'].setValue((userSelected.password).trim());
	}

	// convenience getter for easy access to form fields
	get f() { return this.loginForm.controls; }

	onSubmit() {
		this.submitted = true;

		this.loading = true;
		let res = this.oidc.loginWithPassword(this.loginForm.controls['login'].value.trim(), this.loginForm.controls['password'].value.trim())
			.then(
				isLoginSucces => {
					if (isLoginSucces) {
						localStorage.setItem("loginMail", this.loginForm.controls['login'].value);
						this.getService.getJson("users/me")
							.pipe(
								first()).subscribe(
									result => {
										if (result != null) {
											this.loading = true;
											// this.deviceService.encrypteData("currentUserLogin", this.loginForm.controls.login.value)
											localStorage.setItem("me", JSON.stringify(result))
											this.deviceService.encrypteDataLocalStorage("currentUserLogin", this.loginForm.controls['login'].value);
											localStorage.setItem("loginMail", this.loginForm.controls['login'].value);
											this.tools.delay(500).then(() => {
												this.router.navigate(['/home']);
											});
											//read historySession and add new session if not exist
										}
										else
											this.loading = false;
									});
					}
					else
						this.loading = false;
				}
			);
	}
}



export interface user {
	login: string,
	password: string
}